var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#paint0_linear_12977_133302)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 38C14 38 20 34.5 28 34.5C37 34.5 42 38 42 38",
    stroke: "url(#paint1_linear_12977_133302)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2842 17.5898L16.7153 24.4118",
    stroke: "url(#paint2_linear_12977_133302)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 17.5898L37.5689 24.4118",
    stroke: "url(#paint3_linear_12977_133302)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12977_133302",
    x1: 59,
    y1: 40.5,
    x2: 3,
    y2: -6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA183",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12977_133302",
    x1: 15.2923,
    y1: 38.6717,
    x2: 16.3202,
    y2: 33.0927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12977_133302",
    x1: 17.6266,
    y1: 20.6551,
    x2: 18.7249,
    y2: 20.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12977_133302",
    x1: 36.6576,
    y1: 20.6551,
    x2: 35.5593,
    y2: 20.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25E35"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowSmile);
export default __webpack_public_path__ + "static/media/low_smile.c58a4acbcfee7dc03a71001abbe8448f.svg";
export { ForwardRef as ReactComponent };